export default (categories) => {
  return { xPids: { newContent: 'FBFI', oldContent: 'FBFI' }, xAllowRefererAccess: false };
};
